module.exports = __webpack_public_path__ + "img/background-document-detail.63787ff5.svg";